import { createColumnHelper } from "@tanstack/react-table";
import { indexer } from "../../../../utils/utils";
// import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useHospitalProductInquiryList } from "../../../../api/member-management/use-hospital-product-inquiry";
import Table from "../../../../components/ui/Table/Table";
import { convertDateToDateTime } from "../../../../helper/formatDate/formate-date";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "처리상태",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              val === "PENDING" ? (
                <span className="text-[#e80000]">답변대기</span>
              ) : (
                "답변완료"
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "관련 상품명",
      cell: InquiryTitle,
    }),

    columnHelper.accessor((row) => row?.question, {
      header: "문의 내용",
      cell: (info) => {
        const val = info.getValue();
        const question = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
        return (
          <div className="w-[10rem] text-center mx-auto">
            {question ? question : "-"}
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "문의일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.answeredAt, {
      header: "답변일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : ""}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function InquiryTitle(props) {
  const val = props.row.original?.productGroup?.name;
  const prodId = props.row.original?.productGroup?.id;
  const navigate = useNavigate();

  const handleToDetail = (prodId) => {
    navigate(`/product-management/product-group/${prodId}`);
  };

  const title = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
  return (
    <div
      className="cursor-pointer underline"
      onClick={() => handleToDetail(prodId)}
    >
      {title ? title : "-"}
    </div>
  );
}

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      확인
    </button>
  );
}

export function HospitalInquiryTable(props) {
  const { filter, id } = props;
  const { isEmpty, getDataTableProps } = useHospitalProductInquiryList(
    filter,
    id
  );
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center text-[14px]">
          등록된 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasSave={false}
          hasPageSizeFilter={false}
          hasSort={false}
          columns={columns(currentPage, pageSize, totalData)}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
